// @flow

import {Tag} from 'docs/util';
import type {MarkdocFragmentRegistration} from 'docs/markdoc';

// The CodeBlock markdoc render function parses through the text inside
// of the code fence looking for highlight tags. It finds the lines that
// correspond to highlighted regions and passes this into the CodeBlock
// React component which then overlays that actual highlights using the
// line ranges.

export const LineHighlight: MarkdocFragmentRegistration = {
  tag: 'highlight',
  localize: false,
  attributes: {
    type: {
      type: String,
      default: 'default',
      description:
        'Set to `add` or `remove` to change the background line color to green or red respectively. Otherwise, defaults to a simple highlight.',
    },
  },
  render(node, config) {
    const attributes = node.renderAttributes(this.attributes, config);
    const keys = (config.variables.keys: any);
    const children = node.renderChildren(config);

    // This tag is used only by the CodeBlock markdoc render function and is flattened out.
    return new Tag(
      'highlight',
      {
        ...attributes,
        value: keys[attributes.type],
      },
      children,
    );
  },
};
